module.exports = __webpack_public_path__ + "img/colegio.d687b3d9.png";